/* (c) Copyright Frontify Ltd., all rights reserved. */

export const AUTOFORMAT_PLUGIN = 'autoformat-plugin';
